import React from 'react';

const AboutPage = () => {
  return (
    <div className="pl-4 pt-8 md:p-8">
      <h1 className="text-3xl font-bold mb-4">About Us</h1>
      {/* Add company information or mission statement here */}
    </div>
  );
};

export default AboutPage;
